export default function () {
    function build(entity) {
        if (!entity) throw Error('No supplied entity.');
        return {
            ...entity,
            event_route: eventRoute(entity),
        };
    }

    async function get(idEvent) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('videos').get('events/' + idEvent);
            item = build(data.event);
        } catch (e) {
            error = useApiError(e);
        }
        return {event: item, error};
    }

    async function post(params) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('videos').post('events', params);
            item = build(data.event);
        } catch (e) {
            error = useApiError(e);
        }
        if (!item) item = params;
        return {event: item, error};
    }

    async function put(idEvent, params) {
        let item = null,
            error = null;
        try {
            const {data} = await useApi('videos').put('events/' + idEvent, params);
            item = build(data.event);
        } catch (e) {
            error = useApiError(e);
        }
        if (!item) item = params;
        return {event: item, error};
    }

    async function remove(idEvent) {
        let error = null;
        try {
            await useApi('videos').delete('events/' + idEvent);
        } catch (e) {
            error = useApiError(e);
        }
        return {error};
    }

    function eventRoute(entity) {
        if (!entity.id_event) return undefined;
        return {
            name: 'events-idEvent',
            params: {
                idEvent: entity.id_event,
            },
        };
    }

    return {build, get, post, put, remove};
}
